import React from "react";
import pdfjsLib from 'pdfjs-dist';
import fgdemoBadgeImage from '../assets/pdf/freedomdemobadge.pdf'
import caferesBadgeImage from '../assets/images/caferes_badge.png'
import sportecBadgeImage from '../assets/images/sportec_badge.png'
import ilojBadgeImage from '../assets/images/iloj_badge.png'
import wellnessBadgeImage from '../assets/images/wellness_badge.png'

import {
  useGetExhibitorByTokenQuery,
  useGetExhibitorByIdQuery,
  ExhibitorModel,
} from '../api'

import { useAppContext } from '../contexts/app'
import { useParams, useLocation } from "react-router-dom";
import { getAuthQueries } from "../utils";

const QRCode = require('qrcode');
const bwipjs = require('bwip-js');

const pdfjsWorker = require('../../node_modules/pdfjs-dist/build/pdf.worker.entry');
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const BadgePage = () => {
  const location = useLocation()
  const key = getAuthQueries(location.search)[1]
  const { badgeId } = useParams<{badgeId: string}>()
  const { authToken } = useAppContext()
  const byTokenRes = useGetExhibitorByTokenQuery({
    fetchPolicy: 'network-only',
    variables: {
      token: authToken!
    }
  });
  const byIdRes = useGetExhibitorByIdQuery({
    fetchPolicy: 'network-only',
    variables: {
      id: key!
    }
  });

  if (!byTokenRes.data && !byIdRes.data) {
    return <></>
  }
  let exhibitor: ExhibitorModel | undefined;
  if (byTokenRes.data) {
    exhibitor = byTokenRes.data.getExhibitorByToken;
  } else {
    exhibitor = byIdRes.data!.getExhibitorById;
  }

  const badge = exhibitor.badges.find(badge => badge.id === badgeId);
  
  const badgeImage = new Image()
  if (exhibitor.exhibition === 'CAFERES2023') {
    badgeImage.src = caferesBadgeImage
  } else if (exhibitor.exhibition === 'SPORTEC2023') {
    badgeImage.src = sportecBadgeImage
  } else if (exhibitor.exhibition === 'ILOJ2023') {
    badgeImage.src = ilojBadgeImage
  } else if (exhibitor.exhibition === 'WELLNESS2023') {
    badgeImage.src = wellnessBadgeImage
  }
  setTimeout(() => {
    const front = document.getElementById('barcode_front') as HTMLCanvasElement;
    const back = document.getElementById('barcode_back') as HTMLCanvasElement;
    // const barcodeOptions = {
    //   bcid: 'code39',
    //   text: badge?.barcodeId,
    //   scale: 2,
    //   height: 8,
    //   includetext: true,
    //   textxalign: 'center',
    // }
    // bwipjs.toCanvas('barcode_front', barcodeOptions);
    // bwipjs.toCanvas('barcode_back', barcodeOptions);
    const qrcodeOptions = {
      errorCorrectionLevel: 'H'
    }
    if (front && badge?.barcodeId) {
      QRCode.toCanvas(front, badge?.barcodeId, qrcodeOptions)
    }
    if (back && badge?.barcodeId) {
      QRCode.toCanvas(back, badge?.barcodeId, qrcodeOptions)
    }
    if (exhibitor!.exhibition === 'FGDEMO') return
    const badgeCanvas = document.getElementById('badge') as HTMLCanvasElement;
    const ctx = badgeCanvas.getContext('2d')
    badgeImage.onload = () => {
      if (ctx) {
        badgeCanvas.height = badgeImage.height;
        badgeCanvas.width = badgeImage.width;
        ctx.drawImage(badgeImage, 0, 0)
      }
    }
  })

  if (exhibitor.exhibition === 'CAFERES2023') {
    return (
      <div className="caferes2023">
        <div className="badge-wrapper">
          <canvas id="barcode_front"></canvas>
          <div className="badge-front text-center">
            <ul className="badge-jp">
              {badge?.companyName && <li className="company-name">{badge?.companyName}</li>}
              {badge?.department && <li>{badge?.department}</li>}
              {badge?.position && <li>{badge?.position}</li>}
              {badge?.displayName && <li>{badge?.displayName}</li>}
            </ul>
          </div>
          <canvas id="badge"></canvas>
        </div>
      </div>
    );
  }
  if (exhibitor.exhibition === 'SPORTEC2023') {
    return (
      <div className="sportec2023">
        <div className="badge-wrapper">
          <canvas id="barcode_front"></canvas>
          <div className="badge-front text-center">
            <ul className="badge-jp">
              {badge?.companyName && <li className="company-name">{badge?.companyName}</li>}
              {badge?.department && <li>{badge?.department}</li>}
              {badge?.position && <li>{badge?.position}</li>}
              {badge?.displayName && <li>{badge?.displayName}</li>}
            </ul>
          </div>
          <canvas id="badge"></canvas>
        </div>
      </div>
    );
  }
  if (exhibitor.exhibition === 'ILOJ2023') {
    return (
      <div className="iloj2023">
        <div className="badge-wrapper">
          <canvas id="barcode_front"></canvas>
          <div className="badge-front text-center">
            <ul className="badge-jp">
              {badge?.companyName && <li className="company-name">{badge?.companyName}</li>}
              {badge?.department && <li>{badge?.department}</li>}
              {badge?.position && <li>{badge?.position}</li>}
              {badge?.displayName && <li>{badge?.displayName}</li>}
            </ul>
          </div>
          <canvas id="badge"></canvas>
        </div>
      </div>
    );
  }
  if (exhibitor.exhibition === 'WELLNESS2023') {
    return (
      <div className="wellness2023">
        <div className="badge-wrapper">
          <canvas id="barcode_front"></canvas>
          <div className="badge-front text-center">
            <ul className="badge-jp">
              {badge?.companyName && <li className="company-name">{badge?.companyName}</li>}
              {badge?.department && <li>{badge?.department}</li>}
              {badge?.position && <li>{badge?.position}</li>}
              {badge?.displayName && <li>{badge?.displayName}</li>}
            </ul>
          </div>
          <canvas id="badge"></canvas>
        </div>
      </div>
    );
  }

  pdfjsLib.getDocument(fgdemoBadgeImage).promise.then(function(pdf: any){
    pdf.getPage(1).then(function(page: any){
      const viewport = page.getViewport(2, 0);
      const canvas = document.getElementById('badge') as HTMLCanvasElement;
      const ctx = canvas.getContext('2d');
      const renderContext = {
        canvasContext: ctx,
        viewport: viewport
      };
      canvas.height = viewport.height;
      canvas.width = viewport.width;
  
      page.render(renderContext);
    })
  })

  return (
    <div className="fgdemo">
      <div className="badge-wrapper">
        <div className="badge-front text-center">
          <canvas id="barcode_front"></canvas>
          <ul className="badge-jp">
            {badge?.companyName && <li className="company-name">{badge?.companyName}</li>}
            {badge?.department && <li>{badge?.department}</li>}
            {badge?.position && <li>{badge?.position}</li>}
            {badge?.displayName && <li>{badge?.displayName}</li>}
          </ul>
          {/* <ul className="badge-en">
            {badge?.companyNameEn && <li className="company-name">{badge?.companyNameEn}</li>}
            {badge?.departmentEn && <li>{badge?.departmentEn} / {badge?.positionEn}</li>}
            {badge?.displayNameEn && <li>{badge?.displayNameEn}</li>}
          </ul> */}
        </div>
        <div className="badge-back text-center">
          <canvas id="barcode_back"></canvas>
          <ul className="badge-jp">
            {badge?.companyName && <li className="company-name">{badge?.companyName}</li>}
            {badge?.department && <li>{badge?.department}</li>}
            {badge?.position && <li>{badge?.position}</li>}
            {badge?.displayName && <li>{badge?.displayName}</li>}
          </ul>
          {/* <ul className="badge-en">
            {badge?.companyNameEn && <li className="company-name">{badge?.companyNameEn}</li>}
            {badge?.departmentEn && <li>{badge?.departmentEn} / {badge?.positionEn}</li>}
            {badge?.displayNameEn && <li>{badge?.displayNameEn}</li>}
          </ul> */}
        </div>
        <canvas id="badge"></canvas>
      </div>
    </div>
  );
}

export default BadgePage;
